import React, { FC, useEffect, useState } from 'react';
import loader from '../../img/loader.png';
import styled, { keyframes } from 'styled-components';

interface Props {
	isLoading: boolean;
}

const spin = keyframes`
  0% { transform: rotate(0deg)}
  100% { transform: rotate(360deg)}
`;

const Container = styled.div<Pick<Props, 'isLoading'>>`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: auto;
	min-height: 100%;
	border-radius: 10px;
	display: ${({ isLoading }) => (isLoading ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	padding: 20px;
	gap: 10px;
	z-index: 3;
	background: linear-gradient(77.38deg, #4d46b1 2.2%, #6a1bba 98.78%);
	border-radius: 5px;
`;

const Counter = styled.div`
	position: absolute;
	font-weight: 700;
	font-size: 24px;
	line-height: 28px;
	color: #ffffff;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const Image = styled.img`
	width: ${({ width }) => width};
	animation: ${spin} 5s linear infinite;
`;

export const Loader: FC<Props> = props => {
	const { isLoading } = props;
	const [count, setCount] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			count <= 99 && setCount(prev => ++prev);
		}, 20);
		count >= 100 && clearInterval(interval);
		return () => clearInterval(interval);
	}, [count]);

	useEffect(() => {
		setCount(0);
	}, [isLoading]);

	return (
		<Container isLoading={isLoading}>
			<Image src={loader} width={165} alt='loader' />
			<Counter>{count}%</Counter>
		</Container>
	);
};
